module.exports = __webpack_public_path__ + "img/tip.c97908c7.png";